<template>
  <Modal
    class="dea-modal-info dea-modal--no-footer"
    :has-full-width="modalFullWidth"
    :visible="true"
    @modalClose="$emit('close-modal')"
  >
    <template #title>{{ operaTimeBook.title }}</template>
    <template #content>
      <p v-if="ebooksList.length" class="dea-heading--medium__s">
        {{ ebooksList.length }}
        <template v-if="ebooksList.length > 1">volumi:</template>
        <template v-else>volume:</template>
      </p>
      <div v-if="ebooksList.length" class="dea-modal-info__ebook-container">
        <div v-for="(ebook, index) in ebooksList" :key="index">
          <img class="dea-modal-info__ebook-cover" :src="ebook.cover_small" />
        </div>
      </div>
      <div class="dea-modal-info__activations">
        <p class="dea-heading--medium__s dea-modal-info__options">Opzioni attivate:</p>
        <div v-for="(activation, index) in activationsList" :key="index" class="dea-modal-info__activation">
          <p class="dea-heading--medium__xm">{{ activation.title }}</p>
          <p class="dea-heading--regular__xm">
            ISBN: <span class="dea-heading--medium__xm">{{ activation.isbn }}</span>
          </p>
          <p v-if="activation.activation_code" class="dea-heading--regular__xm">
            CODICE USATO PER L'ATTIVAZIONE:
            <span class="dea-heading--medium__xm">{{ activation.activation_code }}</span>
          </p>
          <p class="dea-heading--regular__xm">
            Attivato il: {{ activation.activation_date }}
            <template v-if="childName"> a {{ childName }}</template>
            <template v-if="activation.expiration_date"> - Scade il {{ activation.expiration_date }}</template>
          </p>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/patterns/Modal";
import handleWindowResize from "deascuola-storybook/src/components/mixins/handleWindowResize";
import variables from "@/styles/variables.scss";

export default {
  name: "ActivationsModal",
  components: { Modal },
  mixins: [handleWindowResize],
  props: {
    childName: {
      type: String,
      default: null,
    },
    operaTimeBook: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    activationsList() {
      if (this.operaTimeBook.activations && this.operaTimeBook.activations.length > 0) {
        return this.operaTimeBook.activations;
      }
      return [];
    },
    ebooksList() {
      if (this.operaTimeBook.ebooks && this.operaTimeBook.ebooks.length > 0) {
        return this.operaTimeBook.ebooks;
      }
      return [];
    },
    modalFullWidth() {
      const response = this.windowWidth <= variables.bpSizeMedium;
      if (response) document.body.style.overflowY = "hidden";
      return response;
    },
  },
  beforeDestroy() {
    document.body.style.overflowY = "auto";
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$small-cover: 80px;
$ebook-container-height: 160px;

.dea-modal-info {
  .dea-modal {
    overflow-y: auto;
  }
}

.dea-modal__title-container {
  padding-bottom: $space-base;
}

.dea-modal-info__ebook-container {
  @include media("<=s") {
    margin-bottom: $space-base;
  }

  @include media(">s") {
    max-height: $ebook-container-height;
    overflow-y: auto;
  }
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 (-$space-x-small) $space-large;
}

.dea-modal-info__ebook-cover {
  margin: 0 $space-x-small $space-x-small;
  width: $small-cover;
}

.dea-modal-info__activations,
.dea-modal-info__activation {
  margin-bottom: $space-large;
}

.dea-modal-info__options {
  margin-bottom: $space-base;
}
</style>
